import { render, staticRenderFns } from "./RelatedArticle.vue?vue&type=template&id=608badd6&scoped=true&"
import script from "./RelatedArticle.vue?vue&type=script&lang=js&"
export * from "./RelatedArticle.vue?vue&type=script&lang=js&"
import style0 from "./RelatedArticle.vue?vue&type=style&index=0&id=608badd6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608badd6",
  null
  
)

export default component.exports